import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./AdicionarUsuario.css";

const AdicionarUsuario = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    nome: "",
    nome_empresa: "",
    responsavel: "",
    telefone: "",
    email: "",
    qtd_videos_semana: "2",
    carrossel: false,
    legenda_video: false,
    logradouro: "",
    cidade: "",
    cep: "",
    mensalidade: "",
    data_cobranca: "1",
    vencimento_mensalidade: "",
    forma_pagamento: "pix",
    indicacao: "",
    tipo_usuario: "cliente",
    senha: "",
    confirmar_senha: "",
    logo: null,
    cpf_cnpj: "",
    numero: "",
    complemento: "",
    bairro: "",
    estado: ""

  });

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [indicadores, setIndicadores] = useState([]);


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleFileChange = (e) => {
    setFormData((prev) => ({ ...prev, logo: e.target.files[0] }));
  };

  const fetchIndicadores = async () => {
    try {
        const response = await fetch("https://welaunchyou.com.br/crm-wly/listar_indicadores.php", {
            credentials: "include",
        });

        const data = await response.json();

        if (response.ok && data.indicadores) {
            setIndicadores(data.indicadores);
        } else {
            console.error("Erro ao carregar indicadores:", data.error || "Nenhum dado recebido.");
        }
    } catch (err) {
        console.error("Erro ao buscar indicadores:", err);
    }
};

  useEffect(() => {
    fetchIndicadores();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    setError("");

    // **🚨 Verifica se as senhas coincidem**
    if (formData.senha !== formData.confirmar_senha) {
      setError("As senhas não coincidem!");
      setLoading(false);
      return;
    }

    const form = new FormData();
    for (const key in formData) {
      if (key !== "confirmar_senha") { // **Ignora o campo de confirmação**
        form.append(key, formData[key]);
      }
    }

    try {
      const response = await fetch("https://welaunchyou.com.br/crm-wly/adicionar_usuario.php", {
        method: "POST",
        credentials: "include",
        body: form,
      });

      const data = await response.json();

      if (response.ok) {
        setMessage("Usuário cadastrado com sucesso!");
        setTimeout(() => navigate("/gerenciar-usuarios"), 1500);
      } else {
        setError(data.error || "Erro ao cadastrar usuário.");
      }
    } catch (err) {
      setError("Erro ao conectar ao servidor.");
    } finally {
      setLoading(false);
    }
  };

  console.log("📩 Enviando dados ao backend:", formData);

  return (
    <div className="adicionar-titulo">
      <h1>Adicionar Usuário</h1>
      <div className="meus-dados-container">
        <div className="editar-dados-container">
          {message && <p className="success-message">{message}</p>}
          {error && <p className="error-message">{error}</p>}

          <form onSubmit={handleSubmit} encType="multipart/form-data">
            <div className="form-group">
              <label>Nome:</label>
              <input type="text" name="nome" value={formData.nome} onChange={handleChange} required />
            </div>

            <div className="form-group">
              <label>Nome da Empresa:</label>
              <input type="text" name="nome_empresa" value={formData.nome_empresa} onChange={handleChange} required />
            </div>

            <div className="form-group">
    <label>CPF/CNPJ:</label>
    <input 
        type="text" 
        name="cpf_cnpj" 
        value={formData.cpf_cnpj} 
        onChange={handleChange} 
        required 
    />
</div>



            <div className="form-group">
              <label>Responsável:</label>
              <input type="text" name="responsavel" value={formData.responsavel} onChange={handleChange} required />
            </div>

            <div className="form-group">
              <label>Telefone:</label>
              <input type="text" name="telefone" value={formData.telefone} onChange={handleChange} required />
            </div>

            <div className="form-group">
              <label>E-mail:</label>
              <input type="email" name="email" value={formData.email} onChange={handleChange} required />
            </div>

            <div className="form-group">
              <label>Senha:</label>
              <input type="password" name="senha" value={formData.senha} onChange={handleChange} required />
            </div>

            <div className="form-group">
              <label>Confirme sua Senha:</label>
              <input type="password" name="confirmar_senha" value={formData.confirmar_senha} onChange={handleChange} required />
            </div>

            <div className="form-group">
              <label>Logo:</label>
              <input type="file" name="logo" onChange={handleFileChange} accept="image/*" />
            </div>

            <div className="form-group">
              <label>Quantidade de Vídeos por Semana:</label>
              <select name="qtd_videos_semana" value={formData.qtd_videos_semana} onChange={handleChange} required>
                <option value="0">CRM</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="5">5</option>
              </select>
            </div>

            <div className="form-group">
              <label>Carrossel:</label>
              <input type="checkbox" name="carrossel" checked={formData.carrossel} onChange={handleChange} />
            </div>

            <div className="form-group">
              <label>Legenda no Vídeo:</label>
              <input type="checkbox" name="legenda_video" checked={formData.legenda_video} onChange={handleChange} />
            </div>

            <div className="form-group">
              <label>Logradouro:</label>
              <input type="text" name="logradouro" value={formData.logradouro} onChange={handleChange} />
            </div>

            <div className="form-group">
  <label>Número:</label>
  <input type="text" name="numero" value={formData.numero} onChange={handleChange} required />
</div>

<div className="form-group">
  <label>Complemento:</label>
  <input type="text" name="complemento" value={formData.complemento} onChange={handleChange} />
</div>

<div className="form-group">
  <label>Bairro:</label>
  <input type="text" name="bairro" value={formData.bairro} onChange={handleChange} required />
</div>

            <div className="form-group">
              <label>Cidade:</label>
              <input type="text" name="cidade" value={formData.cidade} onChange={handleChange} />
            </div>

            <div className="form-group">
  <label>Estado:</label>
  <input type="text" name="estado" value={formData.estado} onChange={handleChange} required />
</div>

            <div className="form-group">
              <label>CEP:</label>
              <input type="text" name="cep" value={formData.cep} onChange={handleChange} />
            </div>






            <div className="form-group">
              <label>Mensalidade (R$):</label>
              <input type="number" name="mensalidade" value={formData.mensalidade} onChange={handleChange} required />
            </div>

            <div className="form-group">
  <label>Dia de Cobrança:</label>
  <select name="data_cobranca" value={formData.data_cobranca} onChange={handleChange} required>
    {[...Array(30).keys()].map((num) => (
      <option key={num + 1} value={num + 1}>{num + 1}</option>
    ))}
  </select>
</div>


            <div className="form-group">
              <label>Vencimento da Mensalidade:</label>
              <input type="number" name="vencimento_mensalidade" value={formData.vencimento_mensalidade} onChange={handleChange} min="1" max="31" required />
            </div>

            <div className="form-group">
              <label>Forma de Pagamento:</label>
              <select name="forma_pagamento" value={formData.forma_pagamento} onChange={handleChange} required>
                <option value="pix">Pix</option>
                <option value="boleto">Boleto</option>
                <option value="cartao_credito">Cartão de Crédito</option>
              </select>
            </div>

            <div className="form-group">
    <label>Indicação:</label>
    <select name="indicacao" value={formData.indicacao} onChange={handleChange} required>
        <option value="">Selecione um indicador</option>
        {indicadores.map((indicador) => (
            <option key={indicador.id} value={indicador.id}>
                {indicador.id} - {indicador.nome}
            </option>
        ))}
    </select>
</div>


            <div className="form-group">
              <label>Tipo de Usuário:</label>
              <select name="tipo_usuario" value={formData.tipo_usuario} onChange={handleChange} required>
                <option value="cliente">Cliente</option>
                <option value="master">Master</option>
              </select>
            </div>

            <button className="btn-user" type="submit" disabled={loading}>{loading ? "Cadastrando..." : "Cadastrar"}</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdicionarUsuario;
